var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProjectStatusCmp = function SvgProjectStatusCmp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ProjectStatusCMP_svg__a)",
    stroke: "current",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 38.5h7.333l23.834-23.833a5.186 5.186 0 0 0-7.334-7.334L5.5 31.167V38.5ZM26.583 10.083l7.334 7.334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 14.667 12.833 5.5 5.5 12.833 14.667 22M12.833 14.667l-2.75 2.75M29.333 22l9.167 9.167-7.333 7.333L22 29.333M29.333 31.167l-2.75 2.75"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ProjectStatusCMP_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h44v44H0z"
  })))));
};
export default SvgProjectStatusCmp;